<template>
  <div class="offlineTradeList">
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="商户">
          <el-select
            clearable
            v-model="queryParam.busiUserId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethodbusiUser"
            style="width: 200px"
          >
            <el-option
              v-for="item in busiUseroptions"
              :key="item.id"
              :label="item.storeName"
              :value="item.wlUserId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社区">
          <el-select
            clearable
            v-model="queryParam.communityId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethodcommunity"
            style="width: 200px"
          >
            <el-option
              v-for="item in communityList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户">
          <el-select
            clearable
            v-model="queryParam.wlUserId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: 200px"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易方向">
          <el-select
            v-model="queryParam.tradeDirect"
            placeholder="请选择"
            clearable
            style="width: 200px"
          >
            <el-option label="支出" value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="primary" @click="clearsearchQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_div">
      <el-table
        :data="offlineList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        style="width: 100%"
      >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="busiName" label="商家名称"></el-table-column>
        <el-table-column prop="userName" label="交易用户"></el-table-column>
        <el-table-column prop="amount" label="交易金额"></el-table-column>
        <el-table-column prop="createTime" label="交易时间"></el-table-column>
        <el-table-column prop="userAmount" label="用户余额"></el-table-column>
        <el-table-column
          prop="communityName"
          label="用户社区"
        ></el-table-column>
        <el-table-column prop="tradeCate" label="交易名称">
          <template slot-scope="scope">
            <span v-if="scope.row.tradeCate == '0'">线下商店消费</span>
            <span v-if="scope.row.tradeCate == '1'">其他</span>
          </template>
        </el-table-column>
        <el-table-column prop="tradeDriect" label="交易方向">
          <template slot-scope="scope">
            <span v-if="scope.row.tradeDriect == '0'">支出</span>
            <span v-if="scope.row.tradeDriect == '1'">收入</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getLast7Days } from "@/utils/util";
import {
  costRecord,
  frontUserlist,
  addresscommunitylist,
  busiUserlist,
} from "@/api/management";
import { publicMixin } from "@/mixins/publicMixin";
export default {
  name: "offlineTradeList",
  props: {},
  mixins: [publicMixin],
  data() {
    return {
      loading: false,
      bedata: "",
      offlineList: [],
      streetList: [],
      communityList: [],
      busiUseroptions: [],
      queryParam: {
        wlUserId: "",
        tradeDirect: "",
        start: "",
        end: "",
        communityId: "",
        busiUserId: "",
      },
      wlStreetId: "",
      options: [],
    };
  },
  created() {
    // var myDate = new Date();
    // // 获取 特定日期 之前的 第七天
    // let tmpArr = [];
    // tmpArr.push(
    //   moment(myDate.setDate(myDate.getDate() - 7)).format("YYYY-MM-DD HH:mm:ss")
    // );
    // tmpArr.push(moment(new Date().valueOf()).format("YYYY-MM-DD HH:mm:ss"));
    // this.bedata = tmpArr;
    // this.queryParam.start = this.bedata[0];
    // this.queryParam.end = this.bedata[1];
    this.bedata = getLast7Days();
    this.timechange(this.bedata);
    this.getDataList();
  },
  methods: {
    timechange(val) {
      this.queryParam.start = val[0];
      this.queryParam.end = val[1];
    },
    remoteMethodbusiUser(query) {
      let obj = {};
      obj.pageNo = "1";
      obj.pageSize = "9999";
      obj.name = query;
      busiUserlist(obj).then((res) => {
        if (res.code == 200) {
          this.busiUseroptions = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethod(query) {
      this.loading = true;
      frontUserlist({ name: query }).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this.options = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethodcommunity(query) {
      this.name = query;
      this.getaddresscommunitylist(this.name);
    },
    getDataList() {
      let obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.pageNo = this.currentPage;
      obj.pageSize = this.PageSize;
      costRecord(obj).then((res) => {
        if (res.code == 200) {
          this.totalCount = res.data.total;
          this.currentPage = res.data.current;
          this.PageSize = res.data.size;
          this.offlineList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clearsearchQuery() {
      for (let key in this.queryParam) {
        this.queryParam[key] = "";
      }
      this.bedata = getLast7Days();
      this.timechange(this.bedata);
      // 默认显示第几页
      this.currentPage = 1;
      this.PageSize = 10;
    },
    searchQuery() {
      this.currentPage = 1;
      this.getDataList();
    },
    getaddresscommunitylist(name) {
      addresscommunitylist({
        name: name,
      }).then((res) => {
        if (res.code == 200) {
          this.communityList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.offlineTradeList {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
